import Link from "next/link";
import {ImageWithFallback} from "@/components";
import moment from "moment-jalaali";
moment.loadPersian({dialect: "persian-modern"})

export default function ArticleCard({post = {}}) {

    const {title = "", image = "", summary = "", slug = "/", published_at = ""} = post;

    return (
        <div
            className="group relative w-full block rounded-t-[2.625rem] rounded-bl-[2.625rem] rounded-br-3xl overflow-hidden duration-300 outline outline-[3px] outline-pol-blue-light hover:outline-pol-blue">
            <Link href={`/blog/${slug}`} className="absolute w-full h-full left-0 top-0 z-20"/>
            <div className="relative">
                <div className="relative w-full h-[19.438rem] rounded-bl-[2.625rem] overflow-hidden">
                <span
                    className="absolute left-0 top-0 h-full w-full z-10 duration-300 opacity-0 group-hover:opacity-100"
                    style={{background: "linear-gradient(35deg, rgba(59,24,183,0.76) 8%, rgba(100,29,255,0.27) 60%, rgba(100,29,255,0.13) 95%)"}}/>
                    <ImageWithFallback
                        src={image}
                        alt={title}
                        fill
                        className="object-cover"/>
                </div>
                <div
                    className="bg-white h-[3.25rem] absolute -bottom-7 left-10 rounded-t-[1.188rem] min-w-[10.375rem] z-10">
                    <div
                        className="relative flex items-center text-pol-light-brown font-semibold text-sm  w-full h-full px-4">
                        <div className="triangle triangle-r-md triangle-r-white absolute -right-[23px] -bottom-px"/>
                        <div className="triangle triangle-l-md triangle-l-white absolute -left-[23px] -bottom-px"/>
                        <i className="icon-calendar text-lg mb-1 ml-2"/>
                        <time>{moment(published_at).format("jD jMMMM jYYYY")}</time>
                    </div>
                </div>
            </div>

            <div className="mt-7 pr-8 pl-11 pb-5 text-justify text-pol-gray-600">
                <h2 className="mt-3 font-bold text-[1.375rem] leading-[175%] duration-300 group-hover:text-pol-dark-800">{title}</h2>
                <p className="mt-3 leading-[171%] group-hover:text-pol-dark line-clamp-2">{summary}</p>
            </div>
        </div>
    )
}
